import React, {useRef, useState, useEffect} from 'react'
import ConstantObject from '../Components/Constants';
import striptags from 'striptags'
import useWindowDimensions from '../Components/useWindowDimensions';

import {
  PinterestIcon
/*
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,

  InstapaperShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,

  WhatsappShareButton,

  FacebookIcon,
  TwitterIcon,
  WhatsappIcon
  */
} from "react-share";

import domtoimage from 'dom-to-image';

import '../Styles/Social.css'

function TheCanvas(props)
{

  const mainCanvasRef = useRef(null);
  const { height, width } = useWindowDimensions();
  const topgap = 60, leftgap = 55;

  console.log("thecanvas");
  const [isLoading,setIsLoading] = useState(false);
  const [fontsize, setFontsize] = useState(20);
  const [stylebachans, setStylebachans] = useState({
      width: '100%',
      padding: 40,
      fontSize: fontsize + 'px',
      fontWeight: 'bold',
      color: '#222',
      alignSelf: 'center',
    });

  //console.log(props);
  var imgwidth = props.width;
  if ( !(props.width === parseInt(props.width, 10)) ) {
    imgwidth = props.width.replace("px", "");
  }
  var imgheight = props.height;
  if ( !(props.height === parseInt(props.height, 10)) ) {
    imgheight = props.height.replace("px", "");
  }
  var maxwidth = width - 55;
  var maxheight = height - 69;
  var netwidth = maxwidth;
  var netheight = maxheight;
  if (imgheight > imgwidth) {
    netwidth = netheight*(imgwidth/imgheight);
  }
  /*
  console.log(props);
  console.log(width);
  console.log(netwidth);
  console.log(height);
  console.log(netheight);
  */
  if (netwidth > maxwidth) {
    netwidth = maxwidth;
    netheight = netwidth * (imgheight/imgwidth);
  }
  /*
  console.log(netwidth);
  console.log(netheight);
  */

  const [styleimgbgPreview, setStyleimgbgPreview] = useState({
    //position:'absolute',
    //top:0,
    //left:0,
    position: 'absolute',
    top:0,
    left:0,
    backgroundImage: 'url(' + props.backgroundImage + ')',
    backgroundColor: '#fff',
    width: props.width,
    height: props.height,
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: -1
  });
  const [styleimgbg, setStyleimgbg] = useState({
    //position:'absolute',
    //top:0,
    //left:0,
    position: 'absolute',
    top:topgap,
    left:leftgap,
    backgroundImage: 'url(' + props.backgroundImage + ')',
    //backgroundColor: '#f77',
    width: netwidth,
    height: netheight,
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 0
  });

/*
  const DownloadImage = () => {
    const node = mainCanvasRef.current;
    //const aa = this;

    domtoimage.toJpeg(node, { quality: 0.95 })
        .then(function (dataUrl) {

//console.log(dataUrl);
//            aa.setState({saveURL : dataUrl});

/*
            var link = document.createElement('a');
            link.download = 'my-image-name.jpg';
            link.href = dataUrl;
            link.click(); * /
        });

  }
*/

  const AlignToFlex = (a) => {
    if (a === "bottom") {
      return "flex-end";
    }
    if (a === "center") {
      return "center";
    }
    if (a === "top") {
      return "flex-start";
    }
  }

  const DataURItoBlob = (dataURI) => {
    let byteString = atob(dataURI.split(',')[1]);
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {
        type: 'image/jpeg'
    });
  }

  const ChangeFontSize = (change) => {
    var s = fontsize;
    if (change < 0) {
      s = fontsize*0.9;
    }
    else {
      s = fontsize*1.12;
    }

    console.log("new font size" + s);
    setFontsize(s);
  }

  const GenerateImgAndShare = (shareOn) => {
    const node = mainCanvasRef.current;
    //const aa = this;

    domtoimage.toJpeg(node, { quality: 0.95 })
        .then(function (dataUrl) {
      let blob = DataURItoBlob(dataUrl);
      let formData = new FormData();
      formData.append('file', blob);

console.log(blob);

      setIsLoading(true);
      fetch(ConstantObject.quotes_script_root + 'generateshare.php', {
        body: formData,
        method: 'post'
      })
      .then(response => {
console.log(response);
        if (response.ok) {
          console.log("resp ok");
          response.json().then(data => {
            console.log("data ok");
            console.log(data);
            setIsLoading(false);

            var url = "";
            var a = document.createElement('a');

            if (shareOn === "download") {
              a.setAttribute('download', 'bachan.jpg');
              url = data.url_img;
            }
            else if (shareOn === "wh") {
              a.setAttribute('data-action', "share/whatsapp/share");
              //url = "whatsapp://send?text=Bachan by Baba Nand Singh Ji, Baba Narinder Singh Ji\" data-action=\"share/whatsapp/share\"
              url = "https://api.whatsapp.com/send?text=" +
              //encodeURIComponent(data.url_img)
              encodeURIComponent(data.url);
            }
            else if (shareOn === "fb") {
              // share on fb
              a.setAttribute('data-action', "share/whatsapp/share");
              url = "https://www.facebook.com/sharer/sharer.php?u="
                + data.url_img
            }
            else if (shareOn === "pi") {
              url =
                  "http://pinterest.com/pin/create/button/?url="+ encodeURIComponent(data.url)
                + "&media=" + encodeURIComponent(data.url_img)
                + "&description=" + encodeURIComponent("Quotes by Baba Nand Singh Ji, Baba Narinder Singh Ji on Sri Guru Granth Sahib: "
                    + striptags(props.bachan.__html));
            }

            console.log("sharing uri");
            console.log(url);
            /*
            fetch(fburl)
              .then(response => response.json())
              .then(data => {console.log(data)})
              .catch(error => {
                          console.error('There was an error!', error);
                      });
          */

            document.body.appendChild(a);
            a.setAttribute('href', url);
            a.click();
            document.body.removeChild(a);
          });

        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .catch(error => setIsLoading(false));
    });
  }


  useEffect(() => {
    console.log("useEffect");
    setStylebachans({
                width: '100%',
                padding: 40,
                fontSize: fontsize + 'px',
                fontWeight: 'bold',
                color: '#222',
                alignSelf: AlignToFlex(props.textalign.title),
              });
  }, [props.textalign, fontsize]);

  useEffect(() => {
    console.log("useEffect img");
    setStyleimgbgPreview({
      //position:'absolute',
      //top:0,
      //left:0,
      position: 'absolute',
      top:topgap,
      left:leftgap,
      backgroundImage: 'url(' + props.backgroundImage + ')',
      //backgroundColor: '#f77',
      width: netwidth,
      height: netheight,
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'center',
      backgroundPositionY: 'center',
      backgroundSize: 'cover',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      zIndex: 0
    });

    setStyleimgbg({
      //position:'absolute',
      //top:0,
      //left:0,
      position: 'absolute',
      top:0,
      left:0,
      backgroundImage: 'url(' + props.backgroundImage + ')',
      backgroundColor: '#fff',
      width: props.width,
      height: props.height,
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'center',
      backgroundPositionY: 'center',
      backgroundSize: 'cover',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      zIndex: -1
    });

  }, [props.backgroundImage, props.width, props.height, netwidth, netheight]);




  console.log("thecanvas render");
  //console.log(props);

  return (
    <div className="scrolling-wrapper-flexbox2">
      <div className="download-link">
        <div className="social-button1" onClick={() => GenerateImgAndShare("pi")}>
        </div>
        <div className="social-button1" onClick={() => ChangeFontSize(1)}>
          <img src={ConstantObject.quotes_img_root + "font-inc.png"} alt="increase font size"/>
        </div>
        <div className="social-button1" onClick={() => ChangeFontSize(-1)}>
          <img src={ConstantObject.quotes_img_root + "font-dec.png"} alt="decrease font size"/>
        </div>
        <PinterestIcon
          size="2.5rem"
        />
        <div className="social-button1" onClick={() => GenerateImgAndShare("download")}>
          <i className="fas fa-download"></i>
        </div>

        {/*<br/>
        <a href="https://www.facebook.com/sharer/sharer.php?u=http://www.sri.local/quotes/img-shared/posE82E.jpg">DOWNLOAD</a>
        <br/>
        <a href="http://pinterest.com/pin/create/button/?url=http://srigurugranthsahib.org/quotes-app/&media=http://srigurugranthsahib.org/quotes/img-shared/bachan-2.jpg&description=Bachans%20by%20Baba%20Ji" className="pin-it-button" count-layout="horizontal">
        <img border="0" src="//assets.pinterest.com/images/PinExt.png" title="Pin It" /></a>
        */}
      </div>

      <div style={styleimgbgPreview}>
        <div className="ourcredit"><span className="dropshadow">
          You can also create such Postcards on <br/>
          SriGuruGranthSahib.org/quotes-app/ </span>
        </div>
        {
          fontsize &&
          <div style={stylebachans} dangerouslySetInnerHTML={props.bachan}>
          </div>
        }
      </div>
      <div style={styleimgbg} ref={mainCanvasRef}>
        <div className="ourcredit"><span className="dropshadow">
          You can also create such Postcards on <br/>
          SriGuruGranthSahib.org/quotes-app/ </span>
        </div>
        {
          fontsize &&
          <div style={stylebachans} dangerouslySetInnerHTML={props.bachan}>
          </div>
        }
      </div>
    </div>
  )

}

export default TheCanvas;
